import React from 'react'

const ReportStudents = () => {
  return (
    <div>ReportStudents</div>
  )
}

export default ReportStudents